<script>

import config from '@/common/genericPanelConf';
import Service from '@/services/equipment-operation';
import GenericService from '@/services/genericService.js';
import CommonConstants from '@/common/Constants';
import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Utils from '@/common/Utils';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericDataTable from '@/components/generic/GenericDataTable.vue';


export default{
    setup: () => ({ v$: useVuelidate() }),
    components: {
        ResponsiveButton,
        GenericCustomMasterDataAutocompleteV2,
        GenericDataTable
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'denaturantBulkRegistry.page_title');
        this.loadSummary();
    },
    created(){
        this.configuration = config.getConfiguration('DenaturantBulkRegistry');
        this.configurationThreshold = config.getConfiguration('DenaturantBulkThreshold');
    },
    data(){
        return{
            filters: {
                from: Utils.formatDatePlusDays(new Date(), -14),
                to: Utils.formatDatePlusDays(new Date(), 0),
                idRegistryPlant: null,
                idRegistryProduct: null
            },
            data: [],
            newItem: {},
            rechargeItem: {},
            importRequest: {},
            addOperationDialogVisible: false,
            rechargeOperationDialogVisible: false,
            importCvtDialogVisible: false,
            bulkThresholdDialogVisible: false,
            loading: false,
            submitted: false,
            summary: [],
            chartData: {},
            chartOptions: {}
        }
    },
    validations(){
        return {
            filters: {
                from: {required},
                to: {required},
                idRegistryPlant: {required},
                idRegistryProduct: {required},
            }
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
        chartDataSummaryS(){

            if(this.summary && this.summary.length > 0){
                let summaryS = this.summary.filter(item => item.registryPlant == 'ISABSUD');
                let runningLowThreshold = summaryS[0].runningLowThreshold;

                const labels = [''].concat(summaryS.map(item => item.registryProduct.split(' - ')[1].replace("DENATURANTE ", ""))).concat(['']);
                const valuesEmpty = [0].concat(summaryS.map((item) => 100 - item.fillingPercentage)).concat([0]);
                const valuesFull = [0].concat(summaryS.map(item => item.fillingPercentage)).concat([0]);
                const threshold = [runningLowThreshold].concat(summaryS.map(item => item.runningLowThreshold)).concat([runningLowThreshold]);
                const colors = [''].concat(summaryS.map((item,i) => item.bulkColor)).concat(['']);

                return {
                    labels: labels,
                    datasets: [
                        {
                            type: 'line',
                            label: 'Soglia',
                            borderColor: '#ec644b',
                            borderWidth: 2,
                            fill: false,
                            tension: 1,
                            data: threshold
                        },
                        {
                            type: 'bar',
                            label: 'Giacenza',
                            backgroundColor: colors,
                            data: valuesFull
                        },
                        {
                            type: 'bar',
                            label: 'Consumato',
                            backgroundColor: 'white',
                            borderColor: colors,
                            borderWidth: 1,
                            data: valuesEmpty
                        },
                    ]
                };
            }
            return {};
        },
        chartDataSummaryN(){

            if(this.summary && this.summary.length > 0){
                let summaryS = this.summary.filter(item => item.registryPlant == 'ISABNORD');

                let runningLowThreshold = summaryS[0].runningLowThreshold;

                const labels = [''].concat(summaryS.map(item => item.registryProduct.split(' - ')[1].replace("DENATURANTE ", ""))).concat(['']);
                const valuesEmpty = [0].concat(summaryS.map((item) => 100 - item.fillingPercentage)).concat([0]);
                const valuesFull = [0].concat(summaryS.map(item => item.fillingPercentage)).concat([0]);
                const threshold = [runningLowThreshold].concat(summaryS.map(item => item.runningLowThreshold)).concat([runningLowThreshold]);
                const colors = [''].concat(summaryS.map((item,i) => item.bulkColor)).concat(['']);

                return {
                    labels: labels,
                    datasets: [
                        {
                            type: 'line',
                            label: 'Soglia',
                            borderColor: '#ec644b',
                            borderWidth: 2,
                            fill: false,
                            tension: 1,
                            data: threshold
                        },
                        {
                            type: 'bar',
                            label: 'Giacenza',
                            backgroundColor: colors,
                            data: valuesFull
                        },
                        {
                            type: 'bar',
                            label: 'Consumato',
                            backgroundColor: 'white',
                            borderColor: colors,
                            borderWidth: 1,
                            data: valuesEmpty
                        },
                    ]
                };
            }
            return {};
        },
        chartOptionsN() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                onClick: (event, elements) => {
                    if(this.$store.getters['security/uiPermissions']('denaturantBulkRegistryRechargeButton').isEnabled){
                        if (elements.length > 0) {
                            let summaryS = this.summary.filter(item => item.registryPlant == 'ISABNORD');
                            const index = elements[0].index;
                            if(index > 0){
                                this.filters.idRegistryPlant = summaryS[index-1].idRegistryPlant;
                                this.filters.idRegistryProduct = summaryS[index-1].idRegistryProduct;
                                this.onRechargeOperationClick();
                            }
                        }
                    }
                },
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.formattedValue;
                                return `${label}: ${value}%`;
                            }
                        }
                    },
                    legend: {
                        display: false,
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        stacked: true,
                        ticks: {
                            // display: false
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        beginAtZero: true,
                        stacked: true,
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        },
        chartOptionsS() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                onClick: (event, elements) => {
                    if(this.$store.getters['security/uiPermissions']('denaturantBulkRegistryRechargeButton').isEnabled){
                        if (elements.length > 0) {
                            let summaryS = this.summary.filter(item => item.registryPlant == 'ISABSUD');
                            const index = elements[0].index;
                            if(index > 0){
                                this.filters.idRegistryPlant = summaryS[index-1].idRegistryPlant;
                                this.filters.idRegistryProduct = summaryS[index-1].idRegistryProduct;
                                this.onRechargeOperationClick();
                            }
                        }
                    }
                },
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.formattedValue;
                                return `${label}: ${value}%`;
                            }
                        }
                    },
                    legend: {
                        display: false,
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        stacked: true,
                        ticks: {
                            // display: false
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        beginAtZero: true,
                        stacked: true,
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        }
    },
    methods: {
        loadOperations(valid){
            this.submitted = true;
            if(valid){
                this.loadGrid();
            }
        },
        loadGrid(){
            let filters = this.prepareFilters();
            this.$refs.denaturantBulkGrid.filterFromView(filters, true);
            this.loadSummary();
        },
        loadSummary(){
            this.summary = []
            Service.getDenaturantBulkSummary(response => {
                if(response.success){
                    this.summary = response.data;
                    // this.chartData = this.setChartData();
                    this.chartOptions = this.setChartOptions();
                }
            })
        },
        prepareFilters() {
            let filters = {
                from: this.filters.from,
                to: Utils.formatEndDate(this.filters.to),
                idRegistryPlant: this.filters.idRegistryPlant,
                idRegistryProduct: this.filters.idRegistryProduct
            };

            let cacheData = {
                name: 'DenaturantBulkGrid',
                filters: filters
            };
            this.$store.dispatch("cacheDataStore/setGridCache", cacheData);

            return filters;
        },
        onAddExtractionOperationClick(){
            this.newItem={
                idRegistryPlant: this.filters.idRegistryPlant,
                idRegistryProduct: this.filters.idRegistryProduct
            };
            this.addOperationDialogVisible = true;
        },
        onAddExtractionOperationSave(){
            let data = {
                idRegistryPlant: this.newItem.idRegistryPlant,
                idRegistryProduct: this.newItem.idRegistryProduct,
                operationDate: this.newItem.operationDate,
                newQuantity: this.newItem.newQuantity,
                force: false
            };

            this.$store.dispatch("generic/setLoading", true);
            Service.addExtractionOperation(data, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.addOperationDialogVisible = false;
                    this.loadGrid();
                } else if(response.message == "OPERATION_IN_THE_PAST"){
                    //chiedo se voglio forzare l'inserimento
                    this.$confirm.require({
                        group: 'confirmInsert',
                        message: this.$t('denaturantBulkRegistry.forceInsertInThePast'),
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: this.$t('yes'),
                        rejectLabel: this.$t('no'),
                        accept: () => {
                            data.force = true;
                            this.$store.dispatch("generic/setLoading", true);
                            Service.addExtractionOperation(data, response => {
                                this.$store.dispatch("generic/setLoading", false);
                                if(response.success){
                                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                                    this.addOperationDialogVisible = false;
                                    this.loadGrid();
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                    this.$confirm.close();
                                }
                            });
                        },
                        reject: () => {
                            //callback to execute when user rejects the action
                            this.$confirm.close();
                        }
                    });
                } else {
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        onRechargeOperationClick(){
            if(this.filters.idRegistryPlant == null){
                this.$toast.add({detail: this.$t('denaturantBulkRegistry.selectPlantErrorMessage'), life:3000, severity:'error'});
                return;
            }
            
            if(this.filters.idRegistryProduct == null){
                this.$toast.add({detail: this.$t('denaturantBulkRegistry.selectProductErrorMessage'), life:3000, severity:'error'});
                return;
            }
            
            this.rechargeItem={
                idRegistryPlant: this.filters.idRegistryPlant,
                idRegistryProduct: this.filters.idRegistryProduct,
                operationDate: new Date(),
                newQuantity: 0
            };

            this.getBulkCapacityAndShowRechargeDialog();
        },
        onRechargeOperationSave(){

            this.$confirm.require({
                message: this.$t('denaturantBulkRegistry.rechargeInsertMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let data = {
                        idRegistryPlant: this.rechargeItem.idRegistryPlant,
                        idRegistryProduct: this.rechargeItem.idRegistryProduct,
                        operationDate: this.rechargeItem.operationDate,
                        newQuantity: this.rechargeItem.newQuantity,
                        force: false
                    };

                    this.$store.dispatch("generic/setLoading", true);
                    Service.rechargeDenaturantBulk(data, response => {
                        this.$store.dispatch("generic/setLoading", false);
                        if(response.success){
                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                            this.rechargeOperationDialogVisible = false;
                            this.loadGrid();
                        } else if(response.message == "OPERATION_IN_THE_PAST"){
                            //chiedo se voglio forzare l'inserimento
                            this.$confirm.require({
                                group: 'confirmInsert',
                                message: this.$t('denaturantBulkRegistry.forceInsertInThePast'),
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: this.$t('yes'),
                                rejectLabel: this.$t('no'),
                                accept: () => {
                                    data.force = true;
                                    this.$store.dispatch("generic/setLoading", true);
                                    Service.rechargeDenaturantBulk(data, response => {
                                        this.$store.dispatch("generic/setLoading", false);
                                        if(response.success){
                                            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                                            this.rechargeOperationDialogVisible = false;
                                            this.loadGrid();
                                        }else{
                                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                            this.$confirm.close();
                                        }
                                    });
                                },
                                reject: () => {
                                    //callback to execute when user rejects the action
                                    this.$confirm.close();
                                }
                            });
                        } else {
                            this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    });
                },
                reject: () => {
                    this.$confirm.close();
                }
            });
           
        },
        getBulkCapacityAndShowRechargeDialog(){
            let bulkKey = {
                idRegistryPlant: this.rechargeItem.idRegistryPlant,
                idRegistryProduct: this.rechargeItem.idRegistryProduct
            }

            Service.getDenaturantBulkCapacityByPlantAndProduct(bulkKey, response => {
                if(response.success){
                    let data = response.data;

                    this.rechargeItem.newQuantity = data.capacity ?? 0;
                }
                this.rechargeOperationDialogVisible = true;
            });
        },
        onDialogEditSaveClick(newValue, oldValue){
            var request = {
                id: newValue.id,
                movedQuantity: newValue.movedQuantity
            };

            this.$store.dispatch("generic/setLoading", true);
            Service.updateDenaturantBulkOperation(request, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$refs.denaturantBulkGrid.hideDialogEdit();
                    this.loadGrid();
                } else {
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        onImportCvtClick(){
            this.importRequest.referenceDate = Utils.formatDatePlusDays(new Date(), -1);
            this.importRequest.idRegistryPlant = null;
            this.importRequest.idRegistryProduct = null;
            this.importRequest.reImport = false;

            this.importCvtDialogVisible = true;
        },
        onImportCvtSaveClick(){
            this.$store.dispatch("generic/setLoading", true);
            Service.importDenaturatedOperations(this.importRequest, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    this.importCvtDialogVisible = false;
                    this.loadGrid();
                } else {
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        onBulkThresholdDialogClick(){
            this.bulkThresholdDialogVisible = true;
        },
        onDenaturantBulkThresholdDialogEditSaveClick(newValue, oldValue){
            if(!newValue.settingValue || newValue.settingValue < 0 || newValue.settingValue > 100){
                this.$toast.add({detail: this.$t('denaturantBulkRegistry.thresholdSettings.valueNotValid'), life:3000, severity:'error'});
            } else {
                GenericService.put(this.configurationThreshold.api, newValue).then((response) =>{
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                        this.bulkThresholdDialogVisible = false;
                    } else {
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
        },
        setChartData(item) {
            const documentStyle = getComputedStyle(document.documentElement);
            const label = item.registryPlant + ' (' + item.registryProduct  + ')';
            const color = item.fillingPercentage > 30 ? '#93faa5' : '#ec644b'
            return {
                labels: [''],
                datasets: [
                    {
                        type: 'bar',
                        label: label,
                        backgroundColor: 'white', //color,
                        data: [item.fillingPercentage]
                    }
                ]
            };
        },
        setChartOptions() {
            const documentStyle = getComputedStyle(document.documentElement);
            const textColor = documentStyle.getPropertyValue('--text-color');
            const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
            const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

            return {
                onClick: (event, elements) => {
                    if (elements.length > 0) {
                        const index = elements[0].index;
                        const label = myChart.data.labels[index];
                        const value = myChart.data.datasets[0].data[index];
                        // Perform your desired action here
                        alert(`You clicked on ${label}: ${value}`);
                    }
                },
                maintainAspectRatio: false,
                aspectRatio: 0.6,
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: function (context) {
                                const label = context.dataset.label || '';
                                const value = context.formattedValue;
                                return `${label}: ${value}%`;
                            }
                        }
                    },
                    legend: {
                        display: false,
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        stacked: true,
                        ticks: {
                            // display: false
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    },
                    y: {
                        beginAtZero: true,
                        stacked: true,
                        ticks: {
                            color: textColorSecondary
                        },
                        grid: {
                            color: surfaceBorder
                        }
                    }
                }
            };
        }
    }
}
</script>

<template>
    <main>
        <ConfirmDialog group="confirmInsert">
            <template #message="slotProps">
                <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border">
                <i :class="slotProps.message.icon" class="text-6xl text-primary-500"></i>
                <span v-html="slotProps.message.message"></span>
            </div>
            </template>
        </ConfirmDialog>

        <!-- Dialog Nuova Operazione Estrazione -->
        <Dialog v-model:visible="addOperationDialogVisible" :modal="true" >
            <h4>
                {{$t('denaturantBulkRegistry.insertButton')}}
            </h4>
            <div class="grid">
                <div class="col-12">
                    <label>{{$t('registryPlant.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        name="masterdata-registry-plant-combo"
                        api="masterdata/registry-plant-combo"
                        v-model="newItem.idRegistryPlant" />
                </div>
                <div class="col-12">
                    <label>{{$t('product.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        name="masterdata-denaturant-bulk-capacity-combo"
                        api="masterdata/denaturant-bulk-capacity-combo"
                        v-model="newItem.idRegistryProduct" />
                </div>
                <div class="col-12">
                    <label>{{$t('denaturantBulkRegistry.operationDate')}}</label>
                    <Calendar 
                        class="w-full" 
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="true"
                        v-model="newItem.operationDate" />
                </div>
                <div class="col-12">
                    <label>{{$t('denaturantBulkRegistry.movedQuantity')}}</label>
                    <InputText 
                        class="w-full" 
                        type="number" 
                        v-model="newItem.newQuantity" />
                </div>
            </div>
                <template #footer>
                    <Button :label="$t('btn.save')" icon="pi pi-save" @click="onAddExtractionOperationSave" autofocus />
                </template>
        </Dialog>

        <!-- Dialog ricarica bulk -->
        <Dialog v-model:visible="rechargeOperationDialogVisible" :modal="true" >
            <h4>
                {{$t('denaturantBulkRegistry.rechargeButton')}}
            </h4>
            <div class="grid">
                <div class="col-12">
                    <label>{{$t('registryPlant.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        name="masterdata-registry-plant-combo"
                        api="masterdata/registry-plant-combo"
                        :disabled="true"
                        v-model="rechargeItem.idRegistryPlant" />
                </div>
                <div class="col-12">
                    <label>{{$t('product.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        name="masterdata-denaturant-bulk-capacity-combo"
                        api="masterdata/denaturant-bulk-capacity-combo"
                        :disabled="true"
                        v-model="rechargeItem.idRegistryProduct" />
                </div>
                <div class="col-12">
                    <label>{{$t('denaturantBulkRegistry.operationDate')}}</label>
                    <Calendar 
                        class="w-full" 
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="true"
                        v-model="rechargeItem.operationDate" />
                </div>
                <div class="col-12">
                    <label>{{$t('denaturantBulkRegistry.movedQuantity')}}</label>
                    <InputText 
                        class="w-full" 
                        type="number" 
                        v-model="rechargeItem.newQuantity" />
                </div>
            </div>
                <template #footer>
                    <Button :label="$t('btn.save')" icon="pi pi-save" @click="onRechargeOperationSave" autofocus />
                </template>
        </Dialog>

        <!-- Dialog import -->
        <Dialog v-model:visible="importCvtDialogVisible" :modal="true" >
            <div class="grid">
                <div class="col-12">
                    <label>{{$t('denaturantBulkRegistry.referenceDate')}}</label>
                    <Calendar 
                        class="w-full" 
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="false"
                        v-model="importRequest.referenceDate" />
                </div>
                <div class="col-12">
                    <label>{{$t('registryPlant.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        name="masterdata-registry-plant-combo"
                        api="masterdata/registry-plant-combo"
                        v-model="importRequest.idRegistryPlant" />
                </div>
                <div class="col-12">
                    <label>{{$t('product.fk')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        name="masterdata-denaturant-bulk-capacity-combo"
                        api="masterdata/denaturant-bulk-capacity-combo"
                        v-model="importRequest.idRegistryProduct" />
                </div>
                <div class="col-12" v-tooltip.left="$t('denaturantBulkRegistry.forceImportTooltip')">
                    <Checkbox v-model="importRequest.reImport" binary style="margin-right: 5px;"/>
                    <label >{{$t('denaturantBulkRegistry.forceImport')}}</label>
                </div>
            </div>
                <template #footer>
                    <Button :label="$t('btn.save')" icon="pi pi-save" @click="onImportCvtSaveClick" autofocus />
                </template>
        </Dialog>

        <!-- Dialog Soglie -->
        <Dialog v-model:visible="bulkThresholdDialogVisible" :modal="true" style="width:50vw;min-height: 20vh" >
            <div class="grid">
                <div :class="{'col-12': true}" >
                    <GenericDataTable :configuration="configurationThreshold" :category="'denaturant-bulk-threshold'" :name="'denaturant-bulk-threshold'" ref="denaturantBulkThresholdGrid" :onDialogEditSave="onDenaturantBulkThresholdDialogEditSaveClick"/>
                </div>
            </div>
        </Dialog>

        <!-- Filtri e griglia -->
        <div class="formgrid grid" v-if="uiPermissions('BlendingSudNord').isEnabled">
            <div class="col-12 lg:col-2 field">
                <label for="plant" :class="{'p-error':v$.filters.idRegistryPlant.$invalid && submitted}">{{$t('registryPlant.fk')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    field="label"
                    v-model="filters.idRegistryPlant"
                    name="masterdata-registry-plant-combo"
                    api="masterdata/registry-plant-combo"
                    :class="{'p-invalid':v$.filters.idRegistryPlant.$invalid && submitted, 'p-inputtext-sm w-full': true}" />
                <div v-if="(v$.filters.idRegistryPlant.$invalid && submitted) || v$.filters.idRegistryPlant.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.idRegistryPlant.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="idRegistryProduct" :class="{'p-error':v$.filters.idRegistryProduct.$invalid && submitted}">{{$t('product.fk')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    :class="{'p-invalid':v$.filters.idRegistryProduct.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    v-model="filters.idRegistryProduct"
                    name="masterdata-denaturant-bulk-capacity-combo"
                    api="masterdata/denaturant-bulk-capacity-combo" />
                <div v-if="(v$.filters.idRegistryProduct.$invalid && submitted) || v$.filters.idRegistryProduct.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.idRegistryProduct.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="from" :class="{'p-error':v$.filters.from.$invalid && submitted}">{{$t('from')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.from.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.from"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.from.$invalid && submitted) || v$.filters.from.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.from.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-2 field">
                <label for="to" :class="{'p-error':v$.filters.to.$invalid && submitted}">{{$t('to')}}</label>
                <Calendar
                    :class="{'p-invalid':v$.filters.to.$invalid && submitted, 'p-inputtext-sm w-full': true}"
                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                    :dateFormat="constants.DATE_FORMAT_POINT"
                    :showTime="false"
                    v-model="filters.to"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                <div v-if="(v$.filters.to.$invalid && submitted) || v$.filters.to.$pending.$response">
                    <small class="p-error" v-for="error in v$.filters.to.$silentErrors" :key="error.$validator">
                        {{error.$message}}
                    </small>
                </div>
            </div>
            <div class="col-12 lg:col-4 my-5">
                <ResponsiveButton :label="$t('btn.load')" icon="pi pi-replay" class="p-button-sm m-1" @click="loadOperations(!v$.$invalid)"/>
                <ResponsiveButton :label="$t('denaturantBulkRegistry.rechargeButton')" :disabled="!uiPermissions('denaturantBulkRegistryRechargeButton').isEnabled" icon="fa-solid fa-fill-drip" class="p-button-sm p-button-outlined m-1" @click="onRechargeOperationClick"/>
                <ResponsiveButton :label="$t('denaturantBulkRegistry.insertButton')" :disabled="!uiPermissions('denaturantBulkRegistryInsertButton').isEnabled" icon="pi pi-plus" class="p-button-sm p-button-outlined m-1" @click="onAddExtractionOperationClick"/>
                <ResponsiveButton :label="$t('denaturantBulkRegistry.thresholdSettings.gridName')" :disabled="!uiPermissions('denaturantBulkThreshold').isEnabled" icon="pi pi-percentage" class="p-button-sm p-button-outlined m-1" @click="onBulkThresholdDialogClick"/>
                <ResponsiveButton :label="$t('denaturantBulkRegistry.importButton')" v-if="uiPermissions('denaturantBulkRegistryImportButton').isEnabled" icon="fa-solid fa-truck" class="p-button-sm p-button-outlined m-1" @click="onImportCvtClick"/>
            </div>
        </div>

        <div class="grid">
            <div :class="{'col-8': true}" style="height: 70vh" v-if="uiPermissions('BlendingSudNord').isEnabled">
                <Card>
                    <template #content>
                        <GenericDataTable :configuration="configuration" :category="'denaturant-bulk'" :name="'denaturant-bulk'" ref="denaturantBulkGrid" :onDialogEditSave="onDialogEditSaveClick" :onCellDeleteComplete="loadGrid"/>
                    </template>
                </Card>
            </div>
            <div :class="{'col-4': uiPermissions('BlendingSudNord').isEnabled, 'col-12': !uiPermissions('BlendingSudNord').isEnabled && (uiPermissions('OnlyBlendingSud').isEnabled || uiPermissions('OnlyBlendingNord').isEnabled)}">
                <Card class="m-1" v-if="uiPermissions('BlendingSudNord').isEnabled || uiPermissions('OnlyBlendingSud').isEnabled">
                    <template #title>
                         SUD
                    </template>
                    <template #content>
                        <Chart type="bar" :data="chartDataSummaryS" :options="chartOptionsS" class="h-30rem" />
                    </template>
                </Card>
                <Card class="m-1" v-if="uiPermissions('BlendingSudNord').isEnabled || uiPermissions('OnlyBlendingNord').isEnabled">
                    <template #title>
                         NORD
                    </template>
                    <template #content>
                        <Chart type="bar" :data="chartDataSummaryN" :options="chartOptionsN" class="h-30rem" />
                    </template>
                </Card>
            </div>
        </div>
    </main>
</template>

<style lang="css" scoped>
    .full-bulk{
        background-color: #93faa5;
    }

    .empty-bulk{
        background-color: #ec644b;
    }
</style>